import script from "./TextBlockWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBlockWidget.vue?vue&type=script&setup=true&lang=js"

import "./TextBlockWidget.vue?vue&type=style&index=0&id=638ce838&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638ce838"]])

export default __exports__